import {ssr_window} from "./ssr";
import {getQueryObj} from "./query_helper";

const STORAGE_KEY = 'acq_utm_attribution';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_custom'];

// Reads UTM params from the current URL and keeps them in sessionStorage for
// the rest of the browser tab's life. Called once per page load, from
// client.js — not tied to any specific page, since a tracking link can point
// anywhere and the visitor may browse before applying. A later link with its
// own UTM params overwrites the stored ones (last-touch); a plain internal
// link (no params) leaves whatever was already captured untouched.
export const captureUtmAttribution = () => {
  const query = getQueryObj(ssr_window.location?.search);
  const captured = {};
  UTM_KEYS.forEach(key => {
    if (query[key]) {
      captured[key] = decodeURIComponent(query[key]);
    }
  });
  if (!Object.keys(captured).length) {
    return;
  }
  try {
    ssr_window.sessionStorage?.setItem(STORAGE_KEY, JSON.stringify(captured));
  } catch (e) {
    // sessionStorage unavailable (private mode, etc.) — attribution is lost,
    // the application itself must not be.
  }
};

export const getUtmAttribution = () => {
  try {
    const raw = ssr_window.sessionStorage?.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
};
